var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"announce"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }